export default __webpack_public_path__ + "static/media/Blujay Solutions.a889035c.png";